import type { Route } from 'next';
import Link, { type LinkProps } from 'next/link';
import type { ComponentPropsWithRef } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './text-link.module.scss';

type Tone = 'default' | 'muted' | 'inverse';

// Generic like next/link itself, so a literal or template href infers its typed route.
export type TextLinkProps<T extends string = string> = Omit<LinkProps<T>, 'href'> & {
  href: Route<T>;
  tone?: Tone;
};

/** Underlined text action (".tl" in the design). */
export function TextLink<T extends string>({
  href,
  tone = 'default',
  className,
  ...props
}: TextLinkProps<T>) {
  return <Link {...props} href={href} className={cx(styles.root, className)} data-tone={tone} />;
}

export type TextButtonProps = ComponentPropsWithRef<'button'> & { tone?: Tone };

export function TextButton({
  tone = 'default',
  className,
  type = 'button',
  ...props
}: TextButtonProps) {
  return <button {...props} type={type} className={cx(styles.root, className)} data-tone={tone} />;
}
